import { defineMessages } from 'react-intl';

const messages = defineMessages({
  buy_now: {
    id: 'lCILNz',
    defaultMessage: 'Buy Now',
  },
  buy_now_aws: {
    id: '6oJwp/',
    defaultMessage: 'Buy now on AWS',
  },
  buy_now_azure: {
    id: '3DHzfA',
    defaultMessage: 'Buy now on Azure',
  },
  buy_now_ibm: {
    id: 'QYN6ze',
    defaultMessage: 'Buy now on ibm.com',
  },
  buy_now_yours: {
    id: 'pW/ypf',
    defaultMessage: 'Buy yours now!',
  },
  main_header: {
    id: 'Ohwgvv',
    defaultMessage:
      'offers flexible purchasing options across various channels. Please choose the option that aligns best with your business needs/requirements.',
  },
  aws_desc: {
    id: 'jGHHe3',
    defaultMessage:
      'If you are already an AWS customer, buy through AWS to use your existing credits.',
  },
  azure_desc: {
    id: 'ZG7e5H',
    defaultMessage:
      'If you are already an Azure customer, buy through Azure to use your existing credits.',
  },
  ibm_desc: {
    id: 'GpWzcA',
    defaultMessage: 'in a few simple clicks.',
  },
  ibm_desc_buy: {
    id: 'EnCOBJ',
    defaultMessage: 'Buy',
  },
  quote_form_desc: {
    id: 'Zritjr',
    defaultMessage:
      'Engage with our sales team to obtain answers to your questions, discuss your specific requirement, and receive a persolized quote',
  },
  consult_a_seller: {
    id: 'FoZHZ0',
    defaultMessage: 'Consult with a seller',
  },
});

export default messages;
